import React from 'react';
import FailureScreen from '../FailureScreen';

interface ErrorBoundaryProps {
  children: React.ReactNode;
  noText?: boolean;
}

interface ErrorBoundaryState {
  hasError: boolean;
}

// ErrorBoundary component to handle errors during lazy loading (microservice)
class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): ErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: any, errorInfo: any) {
    console.error('Error loading component:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <>
          {!this.props.noText && <FailureScreen>An error occurred while loading this component, please refresh</FailureScreen>}
          {!this.props.noText && null}
        </>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
